<template>
    <v-dialog max-width="720px" v-model="getModalCadastroGrupoFinanceiro">
        <v-card outlined :loading="$store.getters.getOverlay">
            <v-card-title>
                Cadastro de Categoria
            </v-card-title>
            <v-form class="px-3" ref="form">
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 md12>
                            <v-text-field outlined dense class="mr-2 ml-2" v-model="getGrupoFinanceiro.nome" label="Nome" @keyup.13="salvar" :rules="rules.nome"></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="default" @click="setModalCadastroGrupoFinanceiro(false)" outlined>Voltar</v-btn>
                    <v-btn color="primary" v-if="getGrupoFinanceiro.id && $helper.verificaPermissao('cadastrar-categoria-financeiro')" @click="cadastrarGrupoFinanceiro" outlined>Novo</v-btn>
                    <v-btn color="error"  v-if="getGrupoFinanceiro.id && $helper.verificaPermissao('excluir-categoria-financeiro')" @click="setModalExcluirGrupoFinanceiro(true)" outlined>Excluir</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="salvar" outlined v-if="$helper.verificaPermissao('cadastrar-categoria-financeiro') || $helper.verificaPermissao('atualizar-categoria-financeiro')">Salvar</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
        
        <ModalExcluir />
    </v-dialog>
</template>

<script>
    import ModalExcluir from "@/pages/financeiro/grupo/ModalExcluir"
    import { mapGetters, mapActions } from 'vuex'
    export default {
        data(){
            return { 
                rules: {
                    nome: [
                        v => !!v || 'Campo obrigatório.'
                    ]
                }
            }
        },
        components: {
            ModalExcluir
        },
        computed: {
            ...mapGetters([
            'getGrupoFinanceiro',
            'getModalCadastroGrupoFinanceiro',
            ])
        },
        
        methods: {
            ...mapActions([
            'setModalCadastroGrupoFinanceiro',
            'setModalExcluirGrupoFinanceiro',
            'cadastrarGrupoFinanceiro',
            'salvarGrupoFinanceiro',
            'atualizarGrupoFinanceiro',
            ]),
            salvar(){
                if(this.$refs.form.validate()){ 
                    if(this.getGrupoFinanceiro.id){
                        this.atualizarGrupoFinanceiro(this.getGrupoFinanceiro)
                    }else{
                        this.salvarGrupoFinanceiro(this.getGrupoFinanceiro)
                    }
                }
            },
        },
        created(){
        }
    }
</script>